exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-07a070d6] .md-table-head-label {\n  color: #4caf50 !important;\n}\n.label-total[data-v-07a070d6] {\n  float: right;\n  font-size: 14px;\n  font-weight: 500;\n}\n.label-total span[data-v-07a070d6] {\n    display: block;\n}\n.view-map[data-v-07a070d6] {\n  margin-right: 5px;\n  cursor: pointer;\n}\n.view-map[data-v-07a070d6]  .md-icon {\n    color: #2b93ff;\n}\n", ""]);

// exports
